import DashboardList from "./DashboardList";
import DashboardFormPage from "./DashboardFormPage"; 
import DashboardEditorPage from "./DashboardEditorPage";
import { Access } from "/src/utils/access";
const rootSupervision = "company/:company/";
const routes = [
    {path : rootSupervision + 'dashboards/list', component: () => <DashboardList/>, isPublic : false, isSidebar : true , permissions:['view_dashboards']},
    {path : rootSupervision + 'dashboard/create', component: () => <DashboardFormPage/>, isSidebar : true, isPublic : false , permissions:['create_dashboard']},
    {path : rootSupervision + 'dashboard/update', component: (data,type) => <DashboardFormPage data={data} type={type}/>, isSidebar : true, isPublic : false ,permissions:['update_dashboard']},
    {path : rootSupervision + 'dashboard/editor/:id', component: (data) => <DashboardEditorPage data={data} access ={Access.Administrator}/>, isSidebar : true, isPublic : false , permissions:['update_dashboard']},
    {path : rootSupervision + 'dashboard/editor/view/:id', component: (data) => <DashboardEditorPage data={data} access={Access.Client}/>, isSidebar : true, isPublic : false,permissions:['update_dashboard']},

]

export default routes;